import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import '../scss/membershipParent.scss';

const MembershipFeeModal = ({
  open,
  onClose,
  clubLabel = 'Club fee',
  clubAmount,
  discountLabel = '',
  discountAmount = '',
  feeAmount,
  totalAmount,
  totalLabel = 'You pay',
  variant = 'parent',
}) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="modal-overlay membership-fee-modal-overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="membership-fee-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <FaTimes />
        </button>
        <h2 id="membership-fee-title">Fee breakdown</h2>
        <div className="rows">
          {clubAmount ? (
            <div className="row">
              <span>{clubLabel}</span>
              <strong>{clubAmount}</strong>
            </div>
          ) : null}
          {discountAmount ? (
            <div className="row discount">
              <span>{discountLabel || 'Sibling discount'}</span>
              <strong>{discountAmount}</strong>
            </div>
          ) : null}
          {feeAmount ? (
            <div className="row">
              <span>First Whistle fee</span>
              <strong>{feeAmount}</strong>
            </div>
          ) : null}
        <div className="row amount">
            <span>{totalLabel}</span>
            <strong>{totalAmount}</strong>
          </div>
        </div>
        {variant === 'academy' ? (
          <>
            <p>
              We use Stripe Connect, so the club fee goes directly into your account.
              There is no need to wait for funds to be released.
            </p>
            <p>
              The First Whistle fee is taken at the same time.
            </p>
          </>
        ) : (
          <>
            <p>
              This payment is divided up by Stripe. The club fee goes to the club,
              and the First Whistle fee goes to First Whistle.
            </p>
            <p>
              First Whistle fees go towards the running of the account and towards
              local projects. See our{' '}
              <a
                href="https://firstwhistle.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                website
              </a>
              {' '}and social channels for more details.
            </p>
            <p className="thank-you">We thank you.</p>
          </>
        )}
        <div className="modal-actions">
          <button type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MembershipFeeModal;
